import { render } from "./InstrumentsControl.vue?vue&type=template&id=88c46be4&scoped=true"
import script from "./InstrumentsControl.vue?vue&type=script&lang=js"
export * from "./InstrumentsControl.vue?vue&type=script&lang=js"

import "./InstrumentsControl.vue?vue&type=style&index=0&id=88c46be4&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c46be4"]])

export default __exports__